const en = require('./en.json')
const es = require('./es.json')

interface Dictionary<T> {
  [Key: string]: T;
}

export const langDictionary: Dictionary< Dictionary<string> > = {
  en,
  es
}
